export class Bancos {
            public codBanco: number;
            public codBancoErp: string;
            public codEmpresa: number;
            public descripcion: string;
            constructor() { }
    }
